import React, { useState, useEffect } from "react";
import {
  LayoutDashboard,
  LogOut,
  ChevronDown,
  Menu,
  X,
  Search,
  Star,
  Download,
  Printer,
  Moon,
  Sun,
  HelpCircle,
  Sparkles,
} from "lucide-react";

const ORION = () => {
  const [user, setUser] = useState(null);
  const [selectedDashboard, setSelectedDashboard] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [loginError, setLoginError] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [favorites, setFavorites] = useState([]);
  const [darkMode, setDarkMode] = useState(true);
  const [showGuidance, setShowGuidance] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Set favicon
    const setFavicon = () => {
      const link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/svg+xml";
      link.rel = "icon";
      link.href =
        'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><defs><linearGradient id="g" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" style="stop-color:%233b82f6"/><stop offset="100%" style="stop-color:%2306b6d4"/></linearGradient></defs><circle cx="100" cy="100" r="90" fill="%231e293b"/><path d="M 100 30 L 110 100 L 100 170 L 90 100 Z" fill="url(%23g)"/><path d="M 30 100 L 100 110 L 170 100 L 100 90 Z" fill="url(%23g)" opacity="0.5"/><circle cx="100" cy="100" r="8" fill="%2306b6d4"/></svg>';
      document.getElementsByTagName("head")[0].appendChild(link);
    };
    setFavicon();

    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth < 768) setSidebarOpen(false);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    const saved = localStorage.getItem("orion_data");
    if (saved) {
      const data = JSON.parse(saved);
      setFavorites(data.favorites || []);
      setDarkMode(data.darkMode !== undefined ? data.darkMode : true);

      // Restore user session
      if (data.user) {
        setUser(data.user);
        if (data.selectedDashboard) {
          setSelectedDashboard(data.selectedDashboard);
        }
      }
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(
      "orion_data",
      JSON.stringify({
        favorites,
        darkMode,
        user,
        selectedDashboard,
      })
    );
  }, [favorites, darkMode, user, selectedDashboard]);

  const entities = [
    {
      id: "admin",
      name: "Administrateur",
      email: "office-daf@porteofinance.onmicrosoft.com",
      password: "Office_DAF@2024*SiEGe#",
      entity: "Administration",
      level: "full",
      icon: "🏛️",
    },
    {
      id: "dsi",
      name: "DSI GROUP",
      email: "dsi-group@porteofinance.onmicrosoft.com",
      password: "DSI@Porteo-Group2025#",
      entity: "DSI",
      level: "full",
      icon: "💼",
    },
    {
      id: "gravel",
      name: "GRAVEL",
      email: "gravel@porteofinance.onmicrosoft.com",
      password: "Grci@2025*",
      entity: "GRAVEL",
      level: "entity",
      icon: "🏗️",
    },
    {
      id: "pbci",
      name: "PORTEO BTP CI",
      email: "porteobtp-ci@porteofinance.onmicrosoft.com",
      password: "Pbci@2025*",
      entity: "PORTEO BTP CI",
      level: "entity",
      icon: "🏢",
    },
    {
      id: "construction",
      name: "PÔLE CONSTRUCTION",
      email: "daf-construction@porteofinance.onmicrosoft.com",
      password: "Construction@2025*",
      entity: "Pôle Construction",
      level: "pole",
      icon: "🏭",
    },
    {
      id: "technicbeton",
      name: "TECHNIC BETON",
      email: "technicbeton@porteofinance.onmicrosoft.com",
      password: "Tbci@2025",
      entity: "TECHNIC BETON",
      level: "entity",
      icon: "⚙️",
    },
    {
      id: "bsteel",
      name: "BSTEEL",
      email: "bsteel@porteofinance.onmicrosoft.com",
      password: "Bsci@2025*",
      entity: "BSTEEL",
      level: "entity",
      icon: "🔩",
    },
    {
      id: "pbbj",
      name: "PORTEO BTP BJ",
      email: "porteobtp-bj@porteofinance.onmicrosoft.com",
      password: "Pbbj@2025*",
      entity: "PORTEO BTP BJ",
      level: "entity",
      icon: "🇧🇯",
    },
    {
      id: "pbga",
      name: "PORTEO BTP GA",
      email: "porteobtp-ga@porteofinance.onmicrosoft.com",
      password: "Pbga@2025*",
      entity: "PORTEO BTP GA",
      level: "entity",
      icon: "🇬🇦",
    },
    {
      id: "pbtg",
      name: "PORTEO BTP TG",
      email: "porteobtp-tg@porteofinance.onmicrosoft.com",
      password: "Pbtg@2025*",
      entity: "PORTEO BTP TG",
      level: "entity",
      icon: "🇹🇬",
    },
    {
      id: "adress",
      name: "ADRESS IMMOBILIER",
      email: "adress-immo@porteofinance.onmicrosoft.com",
      password: "Adci@2025*",
      entity: "ADRESS IMMOBILIER",
      level: "entity",
      icon: "🏘️",
    },
    {
      id: "axedeco",
      name: "AXE DECO",
      email: "axe-deco@porteofinance.onmicrosoft.com",
      password: "Axci@2025*",
      entity: "AXE DECO",
      level: "entity",
      icon: "🎨",
    },
    {
      id: "paradium",
      name: "PARADIUM",
      email: "paradium@porteofinance.onmicrosoft.com",
      password: "Paci@2025*",
      entity: "PARADIUM",
      level: "entity",
      icon: "🏛️",
    },
    {
      id: "holding",
      name: "PORTEO SA",
      email: "porteo-sa@porteofinance.onmicrosoft.com",
      password: "Psaa@2025*",
      entity: "PORTEO SA",
      level: "holding",
      icon: "🏦",
    },
  ];

  const reports = [
    {
      id: "dashboard",
      name: "Dashboard",
      cat: "Vue d'ensemble",
      url: "https://app.powerbi.com/reportEmbed?reportId=22b79504-05aa-488f-9d9d-25b82321755a&autoAuth=true&ctid=6542b2db-e8ac-4b24-8ef4-f8f00eccf8e5&pageName=ReportSectionc71790ecd55a7ea52358",
      desc: "Vue d'ensemble KPIs",
      guide: "Performances financières avec indicateurs essentiels",
      levels: ["full", "holding", "pole", "entity"],
      icon: "📊",
    },
    {
      id: "ca",
      name: "Rapport CA",
      cat: "Chiffre d'affaires",
      url: "https://app.powerbi.com/reportEmbed?reportId=22b79504-05aa-488f-9d9d-25b82321755a&autoAuth=true&ctid=6542b2db-e8ac-4b24-8ef4-f8f00eccf8e5&pageName=ReportSection3da097152bdc35433453",
      desc: "Analyse CA",
      guide: "Évolution CA par période et segment",
      levels: ["full", "holding", "pole", "entity"],
      icon: "💰",
    },
    {
      id: "pl1",
      name: "P&L Synthétique",
      cat: "Compte de Résultat",
      url: "https://app.powerbi.com/reportEmbed?reportId=22b79504-05aa-488f-9d9d-25b82321755a&autoAuth=true&ctid=6542b2db-e8ac-4b24-8ef4-f8f00eccf8e5&pageName=ReportSectionaf25bb91ab18ab152358",
      desc: "Vue synthétique",
      guide: "Revenus, coûts et résultats",
      levels: ["full", "holding", "pole", "entity"],
      icon: "📈",
    },
    {
      id: "pl2",
      name: "P&L Annuel",
      cat: "Compte de Résultat",
      url: "https://app.powerbi.com/reportEmbed?reportId=22b79504-05aa-488f-9d9d-25b82321755a&autoAuth=true&ctid=6542b2db-e8ac-4b24-8ef4-f8f00eccf8e5&pageName=752a138fee1ce1c91dab",
      desc: "Analyse annuelle",
      guide: "Comparaisons N vs N-1",
      levels: ["full", "holding", "pole", "entity"],
      icon: "📅",
    },
    {
      id: "pl3",
      name: "P&L Mensuel",
      cat: "Compte de Résultat",
      url: "https://app.powerbi.com/reportEmbed?reportId=22b79504-05aa-488f-9d9d-25b82321755a&autoAuth=true&ctid=6542b2db-e8ac-4b24-8ef4-f8f00eccf8e5&pageName=9df478c53ed797054a4e",
      desc: "Suivi mensuel",
      guide: "Pilotage temps réel",
      levels: ["full", "holding", "pole", "entity"],
      icon: "📆",
    },
    {
      id: "pl4",
      name: "P&L Détaillé",
      cat: "Compte de Résultat",
      url: "https://app.powerbi.com/reportEmbed?reportId=22b79504-05aa-488f-9d9d-25b82321755a&autoAuth=true&ctid=6542b2db-e8ac-4b24-8ef4-f8f00eccf8e5&pageName=ReportSection",
      desc: "Drill-down",
      guide: "Analyse complète lignes P&L",
      levels: ["full", "holding", "pole", "entity"],
      icon: "📋",
    },
    {
      id: "pl5",
      name: "Arborescence P&L",
      cat: "Compte de Résultat",
      url: "https://app.powerbi.com/reportEmbed?reportId=22b79504-05aa-488f-9d9d-25b82321755a&autoAuth=true&ctid=6542b2db-e8ac-4b24-8ef4-f8f00eccf8e5&pageName=ReportSection74f441920540b1e22925",
      desc: "Structure hiérarchique",
      guide: "Navigation structure P&L",
      levels: ["full", "holding", "pole", "entity"],
      icon: "🗂️",
    },
    {
      id: "tft",
      name: "TFT",
      cat: "Trésorerie",
      url: "https://app.powerbi.com/reportEmbed?reportId=22b79504-05aa-488f-9d9d-25b82321755a&autoAuth=true&ctid=6542b2db-e8ac-4b24-8ef4-f8f00eccf8e5&pageName=ReportSectionf69af3cb12716486ce76",
      desc: "Flux trésorerie",
      guide: "Flux opérationnels",
      levels: ["full", "holding", "pole"],
      icon: "💵",
    },
    {
      id: "treso",
      name: "Analyse Trésorerie",
      cat: "Trésorerie",
      url: "https://app.powerbi.com/reportEmbed?reportId=22b79504-05aa-488f-9d9d-25b82321755a&autoAuth=true&ctid=6542b2db-e8ac-4b24-8ef4-f8f00eccf8e5&pageName=ReportSection21dcbbb1dcd938b1ee5d",
      desc: "Suivi quotidien",
      guide: "Trésorerie avec prévisions",
      levels: ["full", "holding", "pole", "entity"],
      icon: "💳",
    },
    {
      id: "dettes",
      name: "Dettes Fournisseurs",
      cat: "Fournisseurs",
      url: "https://app.powerbi.com/reportEmbed?reportId=22b79504-05aa-488f-9d9d-25b82321755a&autoAuth=true&ctid=6542b2db-e8ac-4b24-8ef4-f8f00eccf8e5&pageName=ReportSection",
      desc: "Échéancier",
      guide: "Optimisation BFR",
      levels: ["full", "holding", "pole", "entity"],
      icon: "📤",
    },
    {
      id: "paie",
      name: "Paiements Fournisseurs",
      cat: "Fournisseurs",
      url: "https://app.powerbi.com/reportEmbed?reportId=22b79504-05aa-488f-9d9d-25b82321755a&autoAuth=true&ctid=6542b2db-e8ac-4b24-8ef4-f8f00eccf8e5&pageName=ReportSectionc4a5880fd8db8650289b",
      desc: "Historique",
      guide: "Paiements avec délais",
      levels: ["full", "holding", "pole", "entity"],
      icon: "💸",
    },
    {
      id: "crea",
      name: "Créances Clients",
      cat: "Clients",
      url: "https://app.powerbi.com/reportEmbed?reportId=22b79504-05aa-488f-9d9d-25b82321755a&autoAuth=true&ctid=6542b2db-e8ac-4b24-8ef4-f8f00eccf8e5&pageName=ReportSection",
      desc: "Encours clients",
      guide: "Retards et DSO",
      levels: ["full", "holding", "pole", "entity"],
      icon: "📥",
    },
    {
      id: "inter",
      name: "Situation Inter Filiale",
      cat: "Inter-compagnies",
      url: "https://app.powerbi.com/reportEmbed?reportId=22b79504-05aa-488f-9d9d-25b82321755a&autoAuth=true&ctid=6542b2db-e8ac-4b24-8ef4-f8f00eccf8e5&pageName=ReportSection",
      desc: "Relations filiales",
      guide: "Transactions groupe",
      levels: ["full", "holding"],
      icon: "🔄",
    },
    {
      id: "avance",
      name: "Avance de Fonds",
      cat: "Inter-compagnies",
      url: "https://app.powerbi.com/reportEmbed?reportId=22b79504-05aa-488f-9d9d-25b82321755a&autoAuth=true&ctid=6542b2db-e8ac-4b24-8ef4-f8f00eccf8e5&pageName=0739a98c48787751a665",
      desc: "Avances",
      guide: "Gestion avec traçabilité",
      levels: ["full", "holding", "pole"],
      icon: "💼",
    },
    {
      id: "cc",
      name: "Avances CC Associés",
      cat: "Inter-compagnies",
      url: "https://app.powerbi.com/reportEmbed?reportId=22b79504-05aa-488f-9d9d-25b82321755a&autoAuth=true&ctid=6542b2db-e8ac-4b24-8ef4-f8f00eccf8e5&pageName=ReportSection",
      desc: "CC associés",
      guide: "Mouvements CC",
      levels: ["full", "holding"],
      icon: "👥",
    },
    {
      id: "gl",
      name: "GL",
      cat: "Comptabilité",
      url: "https://app.powerbi.com/reportEmbed?reportId=22b79504-05aa-488f-9d9d-25b82321755a&autoAuth=true&ctid=6542b2db-e8ac-4b24-8ef4-f8f00eccf8e5&pageName=ReportSection5fe436827a067b880ad7",
      desc: "Grand Livre",
      guide: "Recherche multicritères",
      levels: ["full", "holding", "pole", "entity"],
      icon: "📚",
    },
    {
      id: "bal",
      name: "Balance",
      cat: "Comptabilité",
      url: "https://app.powerbi.com/reportEmbed?reportId=22b79504-05aa-488f-9d9d-25b82321755a&autoAuth=true&ctid=6542b2db-e8ac-4b24-8ef4-f8f00eccf8e5&pageName=ReportSection4f1e4528926400624853",
      desc: "Balance",
      guide: "Soldes par compte",
      levels: ["full", "holding", "pole", "entity"],
      icon: "⚖️",
    },
  ];

  const handleLogin = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setLoginError("");
    const found = entities.find(
      (u) =>
        u.email.toLowerCase().trim() === loginEmail.toLowerCase().trim() &&
        u.password === loginPassword
    );
    if (found) {
      setUser(found);
      const acc = reports.filter((d) => d.levels.includes(found.level));
      if (acc.length > 0) setSelectedDashboard(acc[0]);
      setLoginEmail("");
      setLoginPassword("");
    } else {
      setLoginError("Email ou mot de passe incorrect");
    }
    return false;
  };

  const handleLogout = () => {
    setUser(null);
    setSelectedDashboard(null);
    setShowUserMenu(false);
    setSearchTerm("");

    // Clear user session from localStorage
    const saved = localStorage.getItem("orion_data");
    if (saved) {
      const data = JSON.parse(saved);
      localStorage.setItem(
        "orion_data",
        JSON.stringify({
          favorites: data.favorites,
          darkMode: data.darkMode,
          user: null,
          selectedDashboard: null,
        })
      );
    }
  };

  const getAccessible = () =>
    user ? reports.filter((d) => d.levels.includes(user.level)) : [];
  const filtered = getAccessible().filter(
    (d) =>
      d.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      d.cat.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const favs = filtered.filter((d) => favorites.includes(d.id));
  const regular = filtered.filter((d) => !favorites.includes(d.id));
  const grouped = regular.reduce((acc, d) => {
    if (!acc[d.cat]) acc[d.cat] = [];
    acc[d.cat].push(d);
    return acc;
  }, {});

  const bg = darkMode ? "bg-gray-900" : "bg-gray-50";
  const card = darkMode ? "bg-gray-800" : "bg-white";
  const txt = darkMode ? "text-gray-100" : "text-gray-800";
  const txt2 = darkMode ? "text-gray-400" : "text-gray-600";
  const bord = darkMode ? "border-gray-700" : "border-gray-200";
  const hov = darkMode ? "hover:bg-gray-700" : "hover:bg-gray-50";
  const glow = darkMode
    ? "hover:shadow-lg hover:shadow-blue-500/20 transition-all duration-300"
    : "hover:shadow-md transition-all duration-300";

  if (!user) {
    return (
      <div
        className={`min-h-screen ${
          darkMode
            ? "bg-gradient-to-br from-gray-900 via-blue-900/20 to-gray-900"
            : "bg-gradient-to-br from-gray-50 via-blue-50 to-gray-50"
        } flex items-center justify-center p-4 relative overflow-hidden`}
      >
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute w-96 h-96 bg-blue-500/10 rounded-full blur-3xl -top-48 -left-48 animate-pulse"></div>
          <div
            className="absolute w-96 h-96 bg-indigo-500/10 rounded-full blur-3xl -bottom-48 -right-48 animate-pulse"
            style={{ animationDelay: "1s" }}
          ></div>
        </div>

        <div
          className={`relative ${card} rounded-2xl shadow-2xl p-8 w-full max-w-md ${bord} border`}
        >
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-24 h-24 mb-4 relative">
              <svg
                viewBox="0 0 200 200"
                className="w-full h-full animate-pulse"
              >
                <defs>
                  <linearGradient
                    id="compassGrad"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="100%"
                  >
                    <stop
                      offset="0%"
                      style={{ stopColor: "#3b82f6", stopOpacity: 1 }}
                    />
                    <stop
                      offset="100%"
                      style={{ stopColor: "#06b6d4", stopOpacity: 1 }}
                    />
                  </linearGradient>
                </defs>
                <circle
                  cx="100"
                  cy="100"
                  r="90"
                  fill="url(#compassGrad)"
                  opacity="0.1"
                />
                <circle
                  cx="100"
                  cy="100"
                  r="75"
                  fill="none"
                  stroke="url(#compassGrad)"
                  strokeWidth="2"
                  opacity="0.3"
                />
                <path
                  d="M 100 30 L 110 100 L 100 170 L 90 100 Z"
                  fill="url(#compassGrad)"
                  opacity="0.9"
                />
                <path
                  d="M 30 100 L 100 110 L 170 100 L 100 90 Z"
                  fill="url(#compassGrad)"
                  opacity="0.5"
                />
                <circle cx="100" cy="100" r="8" fill="#06b6d4" />
              </svg>
              <div className="absolute inset-0 bg-blue-400 rounded-full blur-2xl opacity-20 animate-pulse"></div>
            </div>
            <h1 className={`text-4xl font-bold ${txt} mb-2 tracking-tight`}>
              O R I O N
            </h1>
            <p className={`${txt2} font-medium`}>
              Optimized Reporting Interface
            </p>
            <p className={`text-xs ${txt2} mt-1`}>for Organizations' Needs</p>
            <div className={`mt-4 pt-4 border-t ${bord}`}>
              <p className={`text-xs ${txt2} opacity-60`}>
                Powered by PORTEO GROUP
              </p>
              <p className={`text-xs ${txt2} opacity-60`}>Finance Team</p>
            </div>
          </div>

          <div className="space-y-4">
            <div>
              <label className={`block text-sm font-medium ${txt} mb-2`}>
                Email
              </label>
              <input
                type="email"
                value={loginEmail}
                onChange={(e) => setLoginEmail(e.target.value)}
                onKeyPress={(e) => e.key === "Enter" && handleLogin(e)}
                className={`w-full px-4 py-3 ${card} ${bord} border rounded-lg focus:ring-2 focus:ring-blue-500 ${txt}`}
                placeholder="email@porteofinance.onmicrosoft.com"
              />
            </div>
            <div>
              <label className={`block text-sm font-medium ${txt} mb-2`}>
                Mot de passe
              </label>
              <input
                type="password"
                value={loginPassword}
                onChange={(e) => setLoginPassword(e.target.value)}
                onKeyPress={(e) => e.key === "Enter" && handleLogin(e)}
                className={`w-full px-4 py-3 ${card} ${bord} border rounded-lg focus:ring-2 focus:ring-blue-500 ${txt}`}
                placeholder="••••••••"
              />
            </div>
            {loginError && (
              <div className="bg-red-500/10 border border-red-500/50 text-red-400 px-4 py-3 rounded-lg text-sm">
                {loginError}
              </div>
            )}
            <button
              onClick={handleLogin}
              className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white py-3 rounded-lg font-medium shadow-lg hover:shadow-xl transform hover:scale-[1.02] transition-all"
            >
              Se connecter
            </button>
          </div>

          <div className={`mt-6 pt-6 border-t ${bord}`}>
            <p className={`text-xs ${txt2} text-center opacity-50`}>
              © 2025 PORTEO GROUP - Finance Team
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`flex h-screen ${bg}`}>
      <div
        className={`${
          sidebarOpen ? (isMobile ? "fixed inset-0 z-50" : "w-80") : "w-0"
        } transition-all duration-300 ${card} ${bord} ${
          isMobile ? "" : "border-r"
        } overflow-hidden flex flex-col`}
      >
        {isMobile && sidebarOpen && (
          <div
            className="absolute inset-0 bg-black/50 z-40"
            onClick={() => setSidebarOpen(false)}
          ></div>
        )}

        <div
          className={`${
            isMobile ? "relative z-50 h-full" : "h-full"
          } flex flex-col ${card}`}
        >
          <div className={`p-4 ${bord} border-b`}>
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center">
                  <svg viewBox="0 0 200 200" className="w-full h-full">
                    <defs>
                      <linearGradient
                        id="sidebarCompassGrad"
                        x1="0%"
                        y1="0%"
                        x2="100%"
                        y2="100%"
                      >
                        <stop
                          offset="0%"
                          style={{ stopColor: "#3b82f6", stopOpacity: 1 }}
                        />
                        <stop
                          offset="100%"
                          style={{ stopColor: "#06b6d4", stopOpacity: 1 }}
                        />
                      </linearGradient>
                    </defs>
                    <path
                      d="M 100 30 L 110 100 L 100 170 L 90 100 Z"
                      fill="url(#sidebarCompassGrad)"
                      opacity="0.9"
                    />
                    <path
                      d="M 30 100 L 100 110 L 170 100 L 100 90 Z"
                      fill="url(#sidebarCompassGrad)"
                      opacity="0.5"
                    />
                    <circle cx="100" cy="100" r="8" fill="#06b6d4" />
                  </svg>
                </div>
                <div>
                  <h1 className={`text-lg font-bold ${txt}`}>O R I O N</h1>
                  <p className={`text-xs ${txt2}`}>{user.entity}</p>
                </div>
              </div>
              {isMobile && (
                <button
                  onClick={() => setSidebarOpen(false)}
                  className={`p-2 ${hov} rounded-lg`}
                >
                  <X className="w-5 h-5" />
                </button>
              )}
            </div>

            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input
                type="text"
                placeholder="Rechercher..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className={`w-full pl-10 pr-4 py-2 ${bord} border rounded-lg text-sm ${card} ${txt} focus:ring-2 focus:ring-blue-500`}
              />
            </div>
          </div>

          <div className="flex-1 overflow-y-auto p-4">
            {favs.length > 0 && (
              <div className="mb-4">
                <div
                  className={`text-xs font-semibold ${txt2} uppercase mb-2 px-2 flex items-center`}
                >
                  <Star className="w-3 h-3 fill-current text-yellow-500 mr-2" />
                  Favoris
                </div>
                {favs.map((d) => (
                  <button
                    key={d.id}
                    onClick={() => {
                      setSelectedDashboard(d);
                      setShowGuidance(false);
                      if (isMobile) setSidebarOpen(false);
                    }}
                    className={`w-full text-left px-3 py-3 rounded-lg mb-1 flex items-center space-x-3 ${
                      selectedDashboard?.id === d.id
                        ? "bg-gradient-to-r from-blue-500/20 to-indigo-500/20 border border-blue-500/50"
                        : `${hov} ${bord} border`
                    } ${glow}`}
                  >
                    <span className="text-2xl">{d.icon}</span>
                    <div className="flex-1 min-w-0">
                      <div className={`font-medium text-sm truncate ${txt}`}>
                        {d.name}
                      </div>
                      <div className={`text-xs ${txt2}`}>{d.cat}</div>
                    </div>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setFavorites((prev) =>
                          prev.filter((id) => id !== d.id)
                        );
                      }}
                    >
                      <Star className="w-4 h-4 fill-current text-yellow-500" />
                    </button>
                  </button>
                ))}
              </div>
            )}

            {Object.entries(grouped).map(([cat, list]) => (
              <div key={cat} className="mb-4">
                <div className={`text-xs font-medium ${txt2} mb-2 px-2`}>
                  {cat}
                </div>
                {list.map((d) => (
                  <button
                    key={d.id}
                    onClick={() => {
                      setSelectedDashboard(d);
                      setShowGuidance(false);
                      if (isMobile) setSidebarOpen(false);
                    }}
                    className={`w-full text-left px-3 py-3 rounded-lg mb-1 flex items-center space-x-3 ${
                      selectedDashboard?.id === d.id
                        ? "bg-gradient-to-r from-blue-500/20 to-indigo-500/20 border border-blue-500/50"
                        : `${hov} ${bord} border`
                    } ${glow}`}
                  >
                    <span className="text-2xl">{d.icon}</span>
                    <div className="flex-1 min-w-0">
                      <div className={`font-medium text-sm truncate ${txt}`}>
                        {d.name}
                      </div>
                      <div className={`text-xs ${txt2}`}>{d.desc}</div>
                    </div>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setFavorites((prev) =>
                          prev.includes(d.id)
                            ? prev.filter((id) => id !== d.id)
                            : [...prev, d.id]
                        );
                      }}
                    >
                      <Star
                        className={`w-4 h-4 ${
                          favorites.includes(d.id)
                            ? "fill-current text-yellow-500"
                            : "text-gray-400"
                        }`}
                      />
                    </button>
                  </button>
                ))}
              </div>
            ))}
          </div>

          <div className={`p-4 ${bord} border-t`}>
            <p className={`text-xs ${txt2} text-center opacity-50`}>
              © 2025 PORTEO GROUP
            </p>
            <p className={`text-xs ${txt2} text-center opacity-50`}>
              Finance Team
            </p>
          </div>
        </div>
      </div>

      <div className="flex-1 flex flex-col overflow-hidden">
        <div className={`${card} ${bord} border-b px-4 py-3 shadow-sm`}>
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <button
                onClick={() => setSidebarOpen(!sidebarOpen)}
                className={`p-2 ${hov} rounded-lg transform hover:scale-110 transition-all`}
              >
                {sidebarOpen ? (
                  <X className="w-5 h-5" />
                ) : (
                  <Menu className="w-5 h-5" />
                )}
              </button>
              {selectedDashboard && (
                <div className="flex items-center space-x-3">
                  <span className="text-2xl">{selectedDashboard.icon}</span>
                  <div>
                    <h2 className={`text-xl font-bold ${txt}`}>
                      {selectedDashboard.name}
                    </h2>
                    <p className={`text-sm ${txt2}`}>{selectedDashboard.cat}</p>
                  </div>
                </div>
              )}
            </div>

            <div className="flex items-center space-x-2">
              <button
                onClick={() => setDarkMode(!darkMode)}
                className={`p-2 ${hov} rounded-lg transform hover:scale-110 transition-all`}
                title={darkMode ? "Mode clair" : "Mode sombre"}
              >
                {darkMode ? (
                  <Sun className="w-5 h-5" />
                ) : (
                  <Moon className="w-5 h-5" />
                )}
              </button>

              {selectedDashboard && (
                <>
                  <button
                    onClick={() => setShowGuidance(!showGuidance)}
                    className={`p-2 ${hov} rounded-lg transform hover:scale-110 transition-all ${
                      showGuidance
                        ? "bg-blue-500/20 border border-blue-500/50"
                        : ""
                    }`}
                    title="Guidance"
                  >
                    <HelpCircle className="w-5 h-5" />
                  </button>
                  <button
                    onClick={() => window.print()}
                    className={`p-2 ${hov} rounded-lg transform hover:scale-110 transition-all`}
                    title="Imprimer"
                  >
                    <Printer className="w-5 h-5" />
                  </button>
                  <button
                    onClick={() =>
                      alert("Export: Utilisez le bouton export dans Power BI.")
                    }
                    className={`p-2 ${hov} rounded-lg transform hover:scale-110 transition-all`}
                    title="Exporter"
                  >
                    <Download className="w-5 h-5" />
                  </button>
                </>
              )}

              <div className="relative">
                <button
                  onClick={() => setShowUserMenu(!showUserMenu)}
                  className={`flex items-center space-x-3 px-4 py-2 ${hov} rounded-lg transition-all ${bord} border transform hover:scale-105`}
                >
                  <span className="text-xl">{user.icon}</span>
                  <div className="text-right hidden md:block">
                    <div className={`text-sm font-medium ${txt}`}>
                      {user.name}
                    </div>
                    <div className={`text-xs ${txt2}`}>{user.entity}</div>
                  </div>
                  <ChevronDown className="w-4 h-4" />
                </button>

                {showUserMenu && (
                  <div
                    className={`absolute right-0 mt-2 w-56 ${card} rounded-lg shadow-xl ${bord} border py-1 z-10`}
                  >
                    <div className={`px-4 py-3 ${bord} border-b`}>
                      <div className={`text-sm font-medium ${txt}`}>
                        {user.email}
                      </div>
                      <div className={`text-xs ${txt2} mt-1 capitalize`}>
                        Accès: {user.level}
                      </div>
                    </div>
                    <button
                      onClick={handleLogout}
                      className="w-full text-left px-4 py-2 text-sm text-red-400 hover:bg-red-500/10 flex items-center space-x-2"
                    >
                      <LogOut className="w-4 h-4" />
                      <span>Se déconnecter</span>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {showGuidance && selectedDashboard && (
          <div
            className={`${card} ${bord} border-b p-4 ${
              darkMode ? "bg-blue-500/10" : "bg-blue-50"
            }`}
          >
            <div className="flex items-start space-x-3">
              <div className="w-10 h-10 bg-blue-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                <HelpCircle className="w-6 h-6 text-blue-400" />
              </div>
              <div className="flex-1">
                <h3
                  className={`font-semibold ${txt} mb-1 flex items-center space-x-2`}
                >
                  <Sparkles className="w-4 h-4 text-blue-400" />
                  <span>Guidance Co-Pilote</span>
                </h3>
                <p className={`text-sm ${txt2}`}>{selectedDashboard.guide}</p>
              </div>
              <button
                onClick={() => setShowGuidance(false)}
                className={`${txt2} hover:${txt}`}
              >
                ×
              </button>
            </div>
          </div>
        )}

        <div className="flex-1 overflow-hidden p-4 md:p-6">
          {selectedDashboard ? (
            <div
              className={`h-full ${card} rounded-xl shadow-lg ${bord} border overflow-hidden ${glow}`}
            >
              <iframe
                title={selectedDashboard.name}
                src={selectedDashboard.url}
                className="w-full h-full border-0"
                frameBorder="0"
                allowFullScreen={true}
              />
            </div>
          ) : (
            <div
              className={`h-full flex items-center justify-center ${card} rounded-xl ${bord} border-2 border-dashed`}
            >
              <div className={`text-center ${txt2}`}>
                <LayoutDashboard className="w-16 h-16 mx-auto mb-4 opacity-50" />
                <p className="text-lg font-medium">
                  Sélectionnez un tableau de bord
                </p>
                <p className="text-sm mt-2">
                  Choisissez un rapport dans le menu latéral
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ORION;
